import * as React from 'react';
import { Button, ButtonType } from '../Button/Button.js';
import { Icon } from '../Icon/Icon.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './PaginationButton.scss.js';

var PaginationButtonIconPosition;
(function(PaginationButtonIconPosition2) {
  PaginationButtonIconPosition2["LEFT"] = "LEFT";
  PaginationButtonIconPosition2["RIGHT"] = "RIGHT";
})(PaginationButtonIconPosition || (PaginationButtonIconPosition = {}));
const bem = Bem.create("vai-pagination-button");
const PaginationButton = (props) => {
  const { htmlId, selected, iconName, iconPosition, onClick, disabled, text, className, dataTa } = props;
  const id = useId(htmlId, ["pagination"]);
  const buttonClassName = addClass(bem.block(selected && "selected", (iconName || iconPosition) && "side", !onClick && "ellipsis"), className);
  return /* @__PURE__ */ React.createElement(Button, {
    id: id.toString(),
    buttonType: ButtonType.Link,
    className: buttonClassName,
    disabled,
    onClick,
    dataTa
  }, (iconName && iconPosition && iconPosition === PaginationButtonIconPosition.LEFT || iconName && !iconPosition) && /* @__PURE__ */ React.createElement("span", {
    className: "icon-margin-right"
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: iconName
  })), /* @__PURE__ */ React.createElement("span", {
    className: bem.element("text")()
  }, text.toString()), iconName && iconPosition && iconPosition === PaginationButtonIconPosition.RIGHT && /* @__PURE__ */ React.createElement("span", {
    className: "icon-margin-left"
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: iconName
  })));
};

export { PaginationButton, PaginationButtonIconPosition, PaginationButton as default };
